(() => {
  const GOAL = 4900; // £49.00, Shopify cart amounts are in pence.
  const formatGBP = (pence) => new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP'
  }).format(pence / 100);

  let refreshQueued = false;
  let lastTotal = null;

  async function refreshShippingProgress() {
    const header = document.querySelector('#cart-drawer-header');
    if (!header) return;

    try {
      const response = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      if (!response.ok) return;
      const cart = await response.json();
      const currentHeader = document.querySelector('#cart-drawer-header');
      if (!currentHeader) return;

      let bar = document.querySelector('.cart-drawer__shipping[data-shipping-progress]');
      if (!cart.item_count) {
        bar?.remove();
        lastTotal = cart.total_price;
        return;
      }

      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'cart-drawer__shipping';
        bar.dataset.shippingProgress = 'true';
        bar.setAttribute('role', 'status');
        bar.setAttribute('aria-live', 'polite');
        bar.innerHTML = '<div class="cart-drawer__shipping-copy"></div><div class="cart-drawer__shipping-track" role="progressbar" aria-label="Free shipping progress" aria-valuemin="0" aria-valuemax="4900"><span></span></div>';
        currentHeader.insertAdjacentElement('afterend', bar);
      }

      const remaining = Math.max(0, GOAL - cart.total_price);
      const percent = Math.min(100, (cart.total_price / GOAL) * 100);
      const copy = bar.querySelector('.cart-drawer__shipping-copy');
      const track = bar.querySelector('.cart-drawer__shipping-track');
      const fill = track?.querySelector('span');

      if (copy) {
        copy.textContent = remaining > 0
          ? 'You are ' + formatGBP(remaining) + ' away from FREE SHIPPING'
          : 'You have unlocked FREE SHIPPING';
      }
      if (track) track.setAttribute('aria-valuenow', String(Math.min(GOAL, cart.total_price)));
      if (fill) fill.style.width = percent + '%';
      lastTotal = cart.total_price;
    } catch (error) {
      // Leave the drawer unchanged if the cart endpoint is temporarily unavailable.
    }
  }

  function queueRefresh() {
    if (refreshQueued) return;
    refreshQueued = true;
    requestAnimationFrame(() => {
      refreshQueued = false;
      refreshShippingProgress();
    });
  }

  const observer = new MutationObserver((records) => {
    const changedOutsideProgress = records.some((record) => {
      const target = record.target instanceof Element ? record.target : record.target.parentElement;
      return !target?.closest('.cart-drawer__shipping[data-shipping-progress]');
    });
    if (changedOutsideProgress) queueRefresh();
  });

  function start() {
    if (document.body) observer.observe(document.body, { childList: true, subtree: true });
    refreshShippingProgress();
    document.addEventListener('cart:update', queueRefresh);
    document.addEventListener('cart:change', queueRefresh);
    document.addEventListener('click', (event) => {
      if (event.target.closest('cart-drawer-component button, cart-drawer-component [data-quantity], cart-drawer-component [name="updates[]"]')) {
        window.setTimeout(queueRefresh, 250);
        window.setTimeout(queueRefresh, 800);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();